import { Project } from "../generated/content";
import { Language } from "../context/LanguageContext";

/**
 * Build the "2024 · İzmir · 140 m² · İç Mekan" line.
 *
 * Every part is optional. Studio metadata is filled in over time, and a
 * half-filled project should read as a shorter line rather than showing
 * stray separators or empty slots.
 */
export function projectMeta(project: Project, lang: Language): string {
  return [
    project.year,
    project.location,
    project.area,
    project.workType ? project.workType[lang] || project.workType.tr : "",
  ]
    .map((part) => (part || "").trim())
    .filter(Boolean)
    .join(" · ");
}
